import { useState } from 'react'

export default function PulseHandoverForm({
  onSave,
}: {
  onSave: (input: { accepted_by: string; accepted_at: string; file?: File | null }) => Promise<void>
}) {
  const [name, setName] = useState('')
  const [date, setDate] = useState('')
  const [file, setFile] = useState<File | null>(null)
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState('')
  return (
    <form
      className="pulse-handover"
      data-testid="pulse-closeout-handover-form"
      onSubmit={async (e) => {
        e.preventDefault()
        setBusy(true)
        setErr('')
        try {
          await onSave({ accepted_by: name, accepted_at: date, file })
        } catch (ex) {
          setErr(ex instanceof Error ? ex.message : 'Could not record handover')
        } finally {
          setBusy(false)
        }
      }}
    >
      <label>
        Date
        <input required type="date" data-testid="pulse-handover-date" value={date} onChange={(e) => setDate(e.target.value)} />
      </label>
      <label>
        Accepted by
        <input required data-testid="pulse-handover-name" value={name} onChange={(e) => setName(e.target.value)} />
      </label>
      <label>
        Evidence (optional)
        <input type="file" data-testid="pulse-handover-file" onChange={(e) => setFile(e.target.files?.[0] || null)} />
      </label>
      {err ? <p className="pulse-closeout-helper">{err}</p> : null}
      <button type="submit" className="btn b-dk btn-sm" data-testid="pulse-handover-save" disabled={busy}>
        Record handover
      </button>
    </form>
  )
}
